export default __webpack_public_path__ + "static/media/home-img-5.d23b9722.png";